import React, { useContext, useEffect, useState, useRef } from 'react'

const LineClampItem = (props) => {
    const productDetails = props.productDetails
    const handleFunction = props.handleFunction
    const lineClamp = props.lineClamp
    const name = props.name

    const itemRef = useRef(null)
    const [isOverflowing, setIsOverflowing] = useState(false)

    useEffect(() => {
        const element = itemRef.current
        if (element) {
            setIsOverflowing(element.scrollHeight > element.clientHeight)
        }
    }, [productDetails[name]])

    // console.log(productDetails[name], 'productDetails.name')
    return (
        <div style={{ marginBottom: '8px' }}>
            {/* Text */}
            <p
                ref={itemRef}
                className="lineClampParent"
                onClick={() => handleFunction(productDetails)}
                style={{
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    WebkitLineClamp: props?.lineClamp ? props.lineClamp : '3',
                }}
                dangerouslySetInnerHTML={{
                    __html: `${
                        productDetails.disclaimer
                            ? productDetails.disclaimer + '. '
                            : ''
                    }${productDetails[name] || ''}`,
                }}
            ></p>

            {/* Show More Button */}
            {/* {isOverflowing && (
                <button
                    onClick={() => handleFunction(productDetails)}
                    className="showMoreBtn"
                >
                    Show More
                </button>
            )} */}
        </div>
    )
}

export default LineClampItem
